import { all, fork, put, takeEvery, call, select } from 'redux-saga/effects';
import * as actionTypes from 'appRedux/actions/taxInvoice/auditLogActionType';
import * as actionCreators from 'appRedux/actions/taxInvoice/auditLogActions';
import { userSignOut } from 'appRedux/actions/Auth';
import { API_URL_V1, API_PMS_HEADERS } from 'constants/ApiSetting';
import { APIPostRequest } from 'util/connection';
import { getItems } from 'util/localStorage';
import { TaxInvoiceLogResponse } from 'routes/main/taxInvoice/types';
import { AppState } from 'appRedux/reducers/ReducerState';

function* taxInvoiceLogRequestProcess({
  payload,
}: actionTypes.TaxInvoiceLogRequestAction): Generator<any, void, any> {
  try {
    // Check if SALESTAX is enabled before making API call
    const systemConfig: any = yield select((state: AppState) => state.systemConfig);
    const isSalesTaxEnabled = systemConfig?.dataSource?.interfaces?.SALESTAX === true;

    if (!isSalesTaxEnabled) {
      console.log('Tax Invoice Log API: SALESTAX is disabled, skipping API call');
      yield put(
        actionCreators.taxInvoiceLogSuccess({
          data: {
            result_code: '0',
            result_msg: 'SALESTAX is disabled',
            msg_code: '00',
            result_data: { items: [] },
          },
          status: 200,
          message: 'OK',
        })
      );
      return;
    }

    // ดึง token จาก localStorage
    const { access_token } = yield call(getItems, ['access_token']);

    if (!access_token) {
      console.error('Tax Invoice Log API: Access token is missing');
      yield put(
        actionCreators.taxInvoiceLogError('Authentication token is missing. Please login again.')
      );
      return;
    }

    // Tax Invoice Get Log — call via the PMS salestax proxy (accsys is a separate API service)
    const url = `${API_URL_V1}pms/rpc/salestax/get_logs`;

    API_PMS_HEADERS.headers.Authorization = `Bearer ${access_token}`;

    const response: any = yield call(APIPostRequest, url, payload, API_PMS_HEADERS);

    // APIPostRequest return response.data โดยตรง
    const responseData = response?.data || response;
    const hasResultCode = responseData?.result_code !== undefined;
    const resultCode = responseData?.result_code;

    const isSuccess = (response?.status === 200 || !response?.status) && resultCode === '0';

    if (isSuccess && hasResultCode) {
      const taxInvoiceLogResponse: TaxInvoiceLogResponse = {
        data: {
          result_code: responseData.result_code,
          result_msg: responseData.result_msg || 'Success',
          msg_code: responseData.msg_code,
          result_data: responseData.result_data ?? { items: [] },
        },
        status: response?.status || 200,
        message: response?.message || 'OK',
      };

      yield put(actionCreators.taxInvoiceLogSuccess(taxInvoiceLogResponse));
    } else {
      const errorMessage =
        responseData?.result_msg || response?.message || 'Failed to fetch tax invoice logs';

      yield put(actionCreators.taxInvoiceLogError(errorMessage));

      if (response?.status === 403) {
        const responseDataForError = response?.data || response;
        const errorMsg = responseDataForError?.result_msg || response?.message || errorMessage;
        const errorData = responseDataForError?.data;

        const isAlreadyLoggedOut =
          errorMsg === 'Already logged out' ||
          errorMsg === 'Invalid token, authentication required' ||
          errorData === null ||
          errorData === undefined;

        if (isAlreadyLoggedOut || errorData) {
          yield put(userSignOut());
        }
      }
    }
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    yield put(actionCreators.taxInvoiceLogError(errorMessage, error));
  }
}

function* taxInvoiceLogRequest() {
  yield takeEvery(actionTypes.TAX_INVOICE_LOG_REQUEST, taxInvoiceLogRequestProcess);
}

export default function* rootSaga() {
  yield all([fork(taxInvoiceLogRequest)]);
}
